import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Pagination, Grid, Card, CardContent, TextField, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";
import axios from "axios";

export default function UserDashboard() {
    const APPURL = "https://api.krushiindia-indore.webito.cloud/api"
    const SOCKET_URL = "https://api.krushiindia-indore.webito.cloud";

    const [searchQuery, setSearchQuery] = useState("");
    const [data, setData] = useState([]);
    const [topUserdata, setTopUserData] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalShops, setTotalShops] = useState(0);
    const [dashboardData, setDashboardData] = useState({
        totalShops: 0,
        totalSales: 0,
        totalTokens: 0,
        sameDayToken: 0,
        day45Token: 0,
        samedayAmount: 0,
        day45Amount: 0,
    });
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [timer, setTimer] = useState(0)

    useEffect(() => {
        fetchUserData(page, limit, searchQuery);

        const socket = io(SOCKET_URL, { transports: ["websocket"] });

        socket.on("dataResponse", (rows) => {
            setDashboardData({
                totalShops: rows.totalUsers,
                totalSales: rows.totalAmount,
                totalTokens: rows.totalToken,
                sameDayToken: rows.sameDayTokenSum,
                day45Token: rows.day45TokenSum,
                samedayAmount: rows.sameDayTokenSum * 500000,
                day45Amount: rows.day45TokenSum * 500000
            })
            if (rows && rows.users) {
                setData(rows.users);
                setTotalPages(rows.totalPages);
            }
            fetchUserData(page, limit, searchQuery);
        });

        return () => {
            socket.disconnect();
        };
    }, [page, limit, debouncedSearch]);


    useEffect(() => {
        fetchTopUser();

        const socket = io(SOCKET_URL, { transports: ["websocket"] });

        socket.on("dataResponse", (rows) => {
            if (rows && rows.users) {
                setTopUserData(rows.topUsers);
            }
            fetchTopUser();
        });

        return () => {
            socket.disconnect();
        };
    }, [page, limit]);

    const fetchUserData = async (page, limit, search) => {
        try {
            const body = { limit, page, search };
            const response = await axios.post(`${APPURL}/users`, body, {
                headers: { "Content-Type": "application/json" }
            });
            setTotalShops(response.data.totalUsers)
            setDashboardData({
                totalShops: response.data.totalUsers,
                totalSales: response.data.totalAmount,
                totalTokens: response.data.totalToken,
                sameDayToken: response.data.sameDayTokenSum,
                day45Token: response.data.day45TokenSum,
                samedayAmount: response.data.sameDayTokenSum * 500000,
                day45Amount: response.data.day45TokenSum * 500000
            })
            if (response.data && response.data.users) {
                setData(response.data.users);
                setTotalPages(response.data.totalPages);
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    const fetchTopUser = async () => {
        try {
            const response = await axios.get(`${APPURL}/topUser`, {
                headers: { "Content-Type": "application/json" }
            });
            if (response.data && response.data.topUsers) {
                setTopUserData(response.data.topUsers);
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    }

    const handleDownload = async () => {
        try {
            const response = await axios.get(`${APPURL}/allUsers/download`, {
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'all_users.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Download Error:", error);
        }
    };


    const cardData = [
        { title: "TOTAL SHOPS", value: totalShops, icon: "👤", color: "#2979FF" },
        { title: "TOTAL TOKENS", value: dashboardData.totalTokens, icon: "🎟️", color: "#FBC02D" },
        { title: "TOTAL TOKEN AMOUNT", value: dashboardData.samedayAmount, icon: "🎟️", color: "red" },
        // { title: "TOTAL 45 DAY TOKEN", value: dashboardData.day45Token, icon: "🎟️", color: "#ff1493" },
        // { title: "TOTAL 45 DAY TOKEN AMOUNT", value: dashboardData.day45Amount, icon: "🎟️", color: "#ff1493" },
    ];

    return (
        <>
            <div>
                <Typography variant="h4" align="center" gutterBottom>
                    Shop Performance Dashboard
                </Typography>

                <Grid container spacing={3} style={{ display: "flex", justifyContent: "center" }}>
                    {cardData.map((item, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <Card sx={{ textAlign: "center", boxShadow: 3, borderLeft: `5px solid ${item.color}`, height: "180px" }}>
                                <CardContent>
                                    <Typography variant="h6" color="textSecondary">
                                        {item.title}
                                    </Typography>
                                    <Typography variant="h4" sx={{ color: item.color, fontWeight: "bold" }}>
                                        {item.value}
                                    </Typography>
                                    <Typography variant="h5">{item.icon}</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}

                </Grid>

                <div style={{ display: "flex", justifyContent: "center" }}>
                    <TableContainer component={Paper} sx={{ mt: 3, p: 2, borderTop: "4px solid purple;", width: "900px" }}>
                        <div style={{ display: "flex", marginBottom: "16px", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h5" >User Table</Typography>
                            <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                                <TextField
                                    label="Search User"
                                    variant="outlined"
                                    size="small"
                                    value={searchQuery}
                                    onChange={(ev) => {
                                        setSearchQuery(ev.target.value);
                                        let val = (ev.target.value || "").trim();
                                        clearTimeout(timer);
                                        setTimer(
                                            setTimeout(() => {
                                                setPage(1);
                                                setDebouncedSearch(val)
                                            }, 500)
                                        );
                                    }}
                                />
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={handleDownload}
                                    sx={{ textTransform: 'none', height: '40px' }}
                                >
                                    Download
                                </Button>
                            </div>
                        </div>
                        {/* Table Data */}
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                                    <TableCell><b>ID</b></TableCell>
                                    <TableCell><b>User Name</b></TableCell>
                                    <TableCell><b>Shop Name</b></TableCell>
                                    <TableCell><b>Center Name</b></TableCell>
                                    <TableCell><b>Token</b></TableCell>
                                    <TableCell><b>Amount</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.length > 0 ? (
                                    data.map((user, index) => (
                                        <TableRow key={user.id}>
                                            <TableCell>{(page - 1) * limit + (index + 1)}</TableCell>
                                            <TableCell>{user.name}</TableCell>
                                            <TableCell>{user.shopName}</TableCell>
                                            <TableCell>{user.centerName}</TableCell>
                                            <TableCell>{user.sameDayToken}</TableCell>
                                            <TableCell>{user.amount}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center">No data available</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>

                        {data.length > 0 &&
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={(event, value) => { setPage(value); }}
                                sx={{ display: "flex", justifyContent: "center", mt: 2 }}
                            />}
                    </TableContainer>

                    <TableContainer component={Paper} sx={{ mt: 3, p: 2, borderTop: "4px solid #FF7043;", width: "900px" }} style={{ marginLeft: "20px" }}>
                        <Typography variant="h5" sx={{ mb: 2, textAlign: "center" }}>Top Users</Typography>

                        {/* Table Data */}
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                                    <TableCell><b>ID</b></TableCell>
                                    <TableCell><b>User Name</b></TableCell>
                                    <TableCell><b>Shop Name</b></TableCell>
                                    <TableCell><b>Center Name</b></TableCell>
                                    <TableCell><b>Token</b></TableCell>
                                    <TableCell><b>Amount</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {topUserdata.length > 0 ? (
                                    topUserdata.map((user, index) => (
                                        <TableRow key={user.id}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{user.name}</TableCell>
                                            <TableCell>{user.shopName}</TableCell>
                                            <TableCell>{user.centerName}</TableCell>
                                            <TableCell>{user.sameDayToken}</TableCell>
                                            <TableCell>{user.amount}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center">No data available</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </>
    );
}